export const formatStringToLocale = (string: string) => {
  const isNumber = !isNaN(parseInt(string, 10))
  if (isNumber) {
    const removeCommas = string.replace(/,/g, '') || '0'
    return formatNumberToLocale(parseInt(removeCommas, 10))
  }

  return ''
}

export const formatNumberToLocale = (number: number) => number.toLocaleString('en-GB')

export const formatNumberToCurrency = (number: number) => {
  if (Number.isInteger(number)) {
    return '£' + new Intl.NumberFormat('en-GB').format(number)
  } else {
    return (
      '£' +
      new Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
        number,
      )
    )
  }
}
